import { render, staticRenderFns } from "./DeliveryChargeButton.vue?vue&type=template&id=fe3f0782"
import script from "./DeliveryChargeButton.vue?vue&type=script&lang=js"
export * from "./DeliveryChargeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports